<script>
    import { faEdit, faPen } from "@fortawesome/free-solid-svg-icons";
    import { createEventDispatcher } from "svelte";
    import Fa from "svelte-fa";
    import Button from "../ui/Button.svelte";
    import ClickablePanel from "../ui/ClickablePanel.svelte";
    import EditOffer from "./EditOffer.svelte";
    import RemoveOffer from "./RemoveOffer.svelte";
    import { timestampToDate, timestampToDateTime } from "../../utils/utils";
    import OfferState from "./OfferState.svelte";
    import ToggleOfferVisibility from "./ToggleOfferVisibility.svelte";
    

    export let offer;

    const dispatch = createEventDispatcher();
    let showCode = false;
    
    $: state = getState(offer);

    function getState(offer) {
        if (offer?.status?.delivery === "successful" && offer?.status?.visible === true) {
            return "successful"
        } else if (offer?.status?.delivery === "successful" && offer?.status?.visible === false) {
            return "hidden"
        } else if (offer?.status?.delivery === "scheduled") {
            return "scheduled"
        }
        return "pending"
    }
</script>

<!-- <ClickablePanel on:open={() => {showCode = true}}> -->
<div class="container {state}">
    <div class="info">
        <div class="title">
            <span class="subject">
                {offer.subject}
            </span>
            <OfferState status={offer.status}/>
        </div>
        <span class="message">
            {offer.message}
        </span>
        {#if offer.show_from && offer.show_until}
            <span class="timestamp">{timestampToDateTime(offer.show_from)} - {timestampToDateTime(offer.show_until)}</span>
        {/if}
    </div>
    <div class="actions">
        {#if offer.status?.delivery === "scheduled"}
            <!-- <EditOffer {offer} on:edit={(e) => dispatch("edit", e.detail)}/> -->
            <RemoveOffer {offer} on:remove={(e) => dispatch("remove", e.detail)}/>
        {:else if offer.status?.delivery === "successful"}
            <ToggleOfferVisibility {offer} on:toggle={(e) => dispatch("toggle", e.detail)}/>
        {/if}
    </div>
</div>
<!-- </ClickablePanel> -->

<style>
    .container {
        display: flex;
        justify-content: space-between;
        border-radius: 0.5rem;
        gap: 1.5rem;
        flex-wrap: wrap;
        color: #333;
        background-color: #F5F2EF;
        padding: 1rem;
    }
    
    .container.pending {
        filter: grayscale(1);
    }
    
    .container.successful {
        background-color: rgba(180, 230, 170, 0.2);
    }
    
    .container.hidden {
        background-color: rgba(255, 210, 210, 0.2);
    }
    
    .container.scheduled {
        background-color: rgba(255, 228, 140, 0.2);
    }

    .title {
        display: flex;
        align-items: center;
        gap: 0.7rem;
        line-break: strict;
        text-overflow: ellipsis;
    }

    .info {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }

    .subject {
        font-weight: bold;
    }

    .status {
        font-size: 0.8rem;
    }

    .timestamp {
        font-size: 0.8rem;
    }
</style>